import React from 'react';
import PropTypes from 'prop-types';
import { CuiButton } from '../button';
import { CuiPanel } from '../panel';

export const CuiSignUpForm = ({
  children,
  className,
  title,
  subTitle,
  formUrl,
  buttonLabel,
  ...rest
}) => (
  <CuiPanel
    color="success"
    padding="l"
    className={className}
    sections={[
      <div className="cuiSignUpFormSection" key="cta">
        <div className="cuiSignUpForm__title">{title}</div>
        <div className="cuiSignUpForm__subTitle">{subTitle}</div>
      </div>,
      <div className="cuiSignUpFormSection" key="form">
        <form name="ctaEmailForm" action={formUrl} method="post">
          <label className="cuiSignUpForm__label" htmlFor="cuiSignUpFormEmail">
            Email address
          </label>

          <input
            id="cuiSignUpFormEmail"
            className="cuiSignUpForm__input"
            name="EMAIL"
            type="email"
          />

          <CuiButton color="primary" type="submit" isFullWidth>
            {buttonLabel}
          </CuiButton>
        </form>

        <div className="cuiSignUpForm__subText">{children}</div>
      </div>,
    ]}
    {...rest}
  />
);

CuiSignUpForm.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  formUrl: PropTypes.string,
  buttonLabel: PropTypes.string,
};

CuiSignUpForm.defaultProps = {
  children: undefined,
  className: undefined,
  title: undefined,
  subTitle: undefined,
  formUrl: undefined,
  buttonLabel: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/signUpForm/SignUpForm.js